export const BASE_URL_WEBSITE = 'https://api.tattersallgda.cl'
export const BASE_URL_WEB = 'https://tattersallgda.cl'
// La de abajo es de tcit y la otra es de prueba
export const HOST = 'https://prod-api.rematetattersallgda.com'
//export const HOST = 'https://api.tattersallgda.cl'

export const PATH = {
  AUCTION: `${HOST}/auction`,
  SESSION: `${HOST}/session`,
  GUARANTEES: `${HOST}/guarantee`,
  EMAIL: `${HOST}/email`,
  STORAGE: `${HOST}/storage`,
  REPORT: `${HOST}/report`,
  SOCKET_AUCTION: `${HOST}`,
  LOAD_INIT: `${HOST}/loadinit`,
  INTEGRATION: `${HOST}/integration`,
}

export const STREAMING = {
  WEBRTC: 'wss://media.rematetattersallgda.com',
  URL: 'https://media.rematetattersallgda.com',
  RTMP: 'rtmp://rtmp.rematetattersallgda.com',
  ID_SUFFIX: 'prod',
}

export const WEB = {
  BASE: 'http://localhost:3000',
  HOME: '/',
  EXPIRED: '/expired',
  LOGIN_URL: `https://tattersallgda.cl/login?rol=true`,
}

export const URL_TCIT = {
  BASE: BASE_URL_WEBSITE,
  URL: '/login',
}
export const NAME = 'prod'
